import React, { ErrorInfo } from 'react';
import loadable from '@loadable/component';
import { FormattedMessage } from 'react-intl';
import styles from './legislation_date_picker.module.scss';
import { doctrineAnalytics } from '../../../../utils/analyticsUtils';
import { getDateKey } from '../../../../utils/date-utils/dateUtils';

const DatePicker = loadable(
  () =>
    import(
      /* webpackChunkName: "date-picker" */ '../../../../components/date-picker/DatePicker'
    ),
);

type Props = {
  onChange: (date: Date | Date[]) => void;
  date?: Date;
  legId: string;
  isCode: boolean;
  topParentId: string;
};

export class LegislationDatePicker extends React.Component<Props> {
  componentDidCatch(error: Error, info: ErrorInfo) {
    console.log(error, info);
    if (window.Rollbar)
      window.Rollbar.critical(error, { source: 'legislation-daypicker' });
  }

  changeToApplicableVersion = () => {
    const { onChange, legId, isCode, topParentId } = this.props;
    const analyticsName = isCode
      ? 'LegislationText SeeApplicableVersionClicked'
      : 'LegislationSection SeeApplicableVersionClicked';
    doctrineAnalytics(analyticsName, {
      legislationType: 'code',
      ...(!isCode && { section_id: legId }),
      text_id: topParentId,
      date: getDateKey(new Date()),
    });
    onChange(new Date());
  };

  render() {
    const { date, onChange } = this.props;
    return (
      <div className={styles.container}>
        <DatePicker
          calendarIcon={null}
          clearIcon={null}
          onChange={onChange}
          value={date}
          locale="fr"
        />
        <button
          type="button"
          onClick={this.changeToApplicableVersion}
          className={styles.text}
        >
          <FormattedMessage id="date-picker/LegislationDatePicker.tsx/1" />
        </button>
      </div>
    );
  }
}
